import React, { memo } from 'react'
import { ChevronArrowRightIcon } from '../../assets/icons/ChevronArrowRightIcon'
import { getMergedClassNames } from '../../utils/HTMLutils'
import './AssembleiaItem.scss'
const rootClassName = 'assembleia-item'

export enum AssembleiaModo {
  Presencial = 1,
  TabletDigital = 2,
  AgenciaDigital = 3,
  Digital = 4
}
interface AssembleiaItemProps {
  nomeCooperativa: string
  presencial?: {
    endereco: string
    dataInicio: string
    dataTermino: string
  }
  dataInicio?: string
  dataTermino?: string
  modo?: AssembleiaModo
  onClick?: (evt: any) => void
  language: {
    dataInicio: string
    dataTermino: string
    enderecoDigital: string
    presencial: string
  }
}

function AssembleiaItem(props: AssembleiaItemProps) {
  return (
    <div
      className={getMergedClassNames([
        rootClassName,
        props.modo === AssembleiaModo.Presencial ? 'presencial' : ''
      ])}
    >
      <div
        onClick={props.onClick}
        className={getMergedClassNames([
          `${rootClassName}-first`,
          props.modo === AssembleiaModo.Presencial ? 'presencial' : ''
        ])}
      >
        <div className={`${rootClassName}-left`}>
          <div className={`${rootClassName}-coop`}>
            {props.nomeCooperativa}
            {props.modo === AssembleiaModo.Presencial
              ? ` - ${props.language.presencial}`
              : ''}
          </div>
          <div className={`${rootClassName}-endereco nunito`}>
            {props.modo === AssembleiaModo.Presencial
              ? props.presencial?.endereco
              : props.language.enderecoDigital}
          </div>
        </div>
        <div className={`${rootClassName}-right`}>
          <div className={`${rootClassName}-col-data`}>
            <div className={`${rootClassName}-label-data`}>
              {props.language.dataInicio}
            </div>
            <div className={`${rootClassName}-value-data nunito`}>
              {props.dataInicio}
            </div>
          </div>
          <div className={`${rootClassName}-col-data`}>
            <div className={`${rootClassName}-label-data`}>
              {props.language.dataTermino}
            </div>
            <div className={`${rootClassName}-value-data nunito`}>
              {props.dataTermino}
            </div>
          </div>
          <div className={`${rootClassName}-icon`}>
            <ChevronArrowRightIcon />
          </div>
        </div>
      </div>
      {props.presencial && props.modo !== AssembleiaModo.Presencial && (
        <div className={`${rootClassName}-second`}>
          <div className={`${rootClassName}-left`}>
            <div className={`${rootClassName}-coop`}>
              {props.language.presencial}
            </div>
            <div className={`${rootClassName}-endereco nunito`}>
              {props.presencial.endereco}
            </div>
          </div>
          <div className={`${rootClassName}-right`}>
            <div className={`${rootClassName}-col-data`}>
              <div className={`${rootClassName}-label-data`}>
                {props.language.dataInicio}
              </div>
              <div className={`${rootClassName}-value-data nunito`}>
                {props.presencial.dataInicio}
              </div>
            </div>
            <div className={`${rootClassName}-col-data`}>
              <div className={`${rootClassName}-label-data`}>
                {props.language.dataTermino}
              </div>
              <div className={`${rootClassName}-value-data nunito`}>
                {props.presencial.dataTermino}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default memo(AssembleiaItem)
